import { WAIT_FOR_ACTION } from './index';

export function waitForActionMiddleware(watchTypes: any[], { isDebug }: any = {}) {
  const watching = watchTypes.reduce((acc: any, x: any) => (acc[x] = true) && acc, {});
  const seen: any = {};
  let pendingActions: any[] = [];
  const throwError = (x: any) => {
    throw new Error(`${x} is not watched`);
  };
  const log = isDebug ? console.log : () => {};

  const logWaiting = (action: any) => {
    if (isDebug) {
      const wait = action.payload.waitFor.filter((x: any) => !seen[x]).join(',');
      log('## waiting for', wait);
    }
  };

  return ({ dispatch }: any) => {
    const dispatchWaiting = ({ action, resolve, reject, invokeBeforeDispatch }: any) => {
      const act = dispatch(invokeBeforeDispatch ? action() : action);
      log('## dispatch waiting', act?.type);
      return Promise.resolve(act).then(resolve).catch(reject);
    };

    return (next: any) => (action: any) => {
      const type = action.type && action.type.replace('FETCH_FAILED', 'FETCH_SUCCESS');
      if (type === WAIT_FOR_ACTION) {
        if (action.payload.waitFor.every((x: any) => (watching[x] ? seen[x] : throwError(x)))) {
          dispatchWaiting(action.payload);
        } else {
          pendingActions.push(action);
        }
        return null;
      } else if (type && watching[type]) {
        log('## got', type);
        const result = next(action);
        seen[type] = true;
        if (pendingActions.length) {
          const queue = [...pendingActions];
          pendingActions = [];
          for (const _action of queue) {
            if (_action.payload.waitFor.every((x: any) => seen[x])) {
              dispatch(_action);
            } else {
              logWaiting(_action);
              pendingActions.push(_action);
            }
          }
        }
        return result;
      }
      return next(action);
    };
  };
}
